if (document.getElementById('leftSubMenuToggle')) {
    let leftNavBarToggle = import('../Components/Vanilla/leftNavBarToggle');
}